'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _skeletonScreen = require('@/components/skeleton-screen');

var _skeletonScreen2 = _interopRequireDefault(_skeletonScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var zeroSrc = require('@/static/images/zero.png');
exports.default = {
  props: {
    tag: {
      type: String,
      default: 'ul'
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    errorComp: {
      type: Object,
      default: function _default() {
        return _skeletonScreen2.default;
      }
    },
    loadingComp: {
      type: Object,
      default: function _default() {
        return _skeletonScreen2.default;
      }
    },
    currentComp: {
      type: Object,
      default: function _default() {
        return {};
      },

      required: true
    },
    delay: {
      type: Number,
      default: 0
    },
    timeout: {
      type: Number,
      default: 10000
    },
    loadding: {
      type: Boolean,
      default: true
    }
  },
  components: {
    SkeletonScreen: _skeletonScreen2.default
  },
  created: function created() {
    var _this = this;

    //$options.components同名冲突问题
    this.$options.components['list' + this._uid] = function () {
      return {
        component: new _promise2.default(function (resolve, reject) {
          _this.resolved = resolve;
        }),
        loadding: _this.loadingComp,
        error: _this.errorComp,
        delay: _this.delay,
        timeout: _this.timeout
      };
    };
  },

  watch: {
    list: {
      immediate: true,
      handler: function handler(newVal) {
        var _this2 = this;

        if (newVal.length >= 1) {
          this.$nextTick(function () {
            _this2.resolved(_this2.currentComp);
          });
        }
      }
    }
  },
  render: function render() {
    var _this3 = this;

    /*eslint-disable*/
    var childRender = void 0;
    if (!this.loadding && !this.list.length) {
      childRender = [this._c({
        template: '<h1 class="iv-text-center iv-m-t-24">\n                      <img :src="src" />\n                    </h1>',
        data: function data() {
          return {
            src: zeroSrc
          };
        }
      })];
    } else if (this.loadding) {
      childRender = [this._c(_skeletonScreen2.default)];
    } else {
      childRender = this._l(this.list, function (item, $index) {
        return _this3._c('list' + _this3._uid, {
          props: (0, _extends3.default)({
            item: item,
            index: $index
          }, _this3.$attrs)
        });
      });
    }
    return this._c(this.tag, childRender);
  }
};